import React from 'react';

// Shows the 24h SLA state for a review or request. Blue = on time, orange =
// due-soon or breached (palette rule: orange is the only warning color).
export default function SlaBadge({ dueAt, breachedAt }) {
  if (!dueAt) return null;
  const now = Date.now();
  const due = new Date(dueAt).getTime();
  if (Number.isNaN(due)) return null; // don't render a misleading badge for bad input
  const breached = !!breachedAt || due < now;
  const dueSoon = !breached && due - now < 4 * 3600 * 1000;
  const cls = breached
    ? 'bg-orange-100 text-orange-800'
    : dueSoon
    ? 'bg-orange-50 text-orange-700'
    : 'bg-blue-50 text-blue-700';
  const label = breached ? 'SLA breached' : dueSoon ? 'Due soon' : 'On time';
  return <span className={`px-2 py-0.5 rounded text-xs font-medium ${cls}`}>{label}</span>;
}
